import { type ParallelCommandJob } from "~/components/build/Show/lib/types/CommandJob";

export const ParallelJobIndex = ({ job }: { job: ParallelCommandJob }) => {
  return (
    <span className="inline-block rounded-[3px] border border-current bg-white px-0.5 text-xs tabular-nums">
      #{job.parallelGroupIndex + 1}
    </span>
  );
};
